// Testimonials.js - Version simplifiée avec design épuré (garder la même structure)
import React, { useRef, useState } from 'react';
import { FaChevronLeft, FaChevronRight, FaQuoteLeft, FaPlay, FaYoutube } from 'react-icons/fa';
import './Testimonials.css';

const Testimonials = () => {
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [hoveredCard, setHoveredCard] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollContainerRef = useRef(null);
  const videoPlayerRef = useRef(null);

  const testimonials = [
    {
      id: 1,
      name: "Yannick KOUASSI",
      quote: "Nous avons accompagné Yannick KOUASSI de son admission dans une école française jusqu'à l'obtention de son VISA.",
      country: "Côte d'Ivoire",
      avatarColor: "#1069d3",
      videoId: "nBGf2rvA0FI",
      thumbnail: "https://img.youtube.com/vi/nBGf2rvA0FI/maxresdefault.jpg",
      duration: "2:34"
    },
    {
      id: 2,
      name: "Wilfried DONGMO",
      quote: "Wilfried DONGMO nous remercie pour l'obtention de son visa.",
      country: "Cameroun",
      avatarColor: "#1e3c72",
      videoId: "81g2ap3AOSI",
      thumbnail: "https://img.youtube.com/vi/81g2ap3AOSI/maxresdefault.jpg",
      duration: "1:45"
    },
    {
      id: 3,
      name: "Noumen BIATO",
      quote: "L'étudiante Noumen BIATO nous a sollicités pour l'accompagnement personnalisé.",
      country: "Togo",
      avatarColor: "#dc143c",
      videoId: "bMatqx9ePZg",
      thumbnail: "https://img.youtube.com/vi/bMatqx9ePZg/maxresdefault.jpg",
      duration: "3:12"
    },
    {
      id: 4,
      name: "Aminata DIALLO",
      quote: "Grâce à ETEF, j'ai pu intégrer une grande école d'ingénieurs à Paris.",
      country: "Sénégal",
      avatarColor: "#1069d3",
      videoId: "C-XLT156cWA",
      thumbnail: "https://img.youtube.com/vi/C-XLT156cWA/maxresdefault.jpg",
      duration: "2:18"
    },
    {
      id: 5,
      name: "Jean KABORE",
      quote: "L'équipe d'ETEF m'a guidé à chaque étape de mon processus d'admission.",
      country: "Burkina Faso",
      avatarColor: "#1e3c72",
      videoId: "KVucI2YrVmc",
      thumbnail: "https://img.youtube.com/vi/KVucI2YrVmc/maxresdefault.jpg",
      duration: "2:56"
    },
    {
      id: 6,
      name: "Fatou DIOP",
      quote: "Le soutien pour l'obtention du visa a été crucial. Merci à toute l'équipe.",
      country: "Sénégal",
      avatarColor: "#dc143c",
      videoId: "wqD1lYRhBQU",
      thumbnail: "https://img.youtube.com/vi/wqD1lYRhBQU/maxresdefault.jpg",
      duration: "1:58"
    }
  ];

  const openVideoModal = (testimonial) => {
    setSelectedVideo(testimonial);
    setShowVideoModal(true);
  };

  const closeVideoModal = () => {
    setShowVideoModal(false);
    setSelectedVideo(null);
  };

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: -380, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: 380, behavior: 'smooth' });
    }
  };

  const scrollToIndex = (index) => {
    if (scrollContainerRef.current) {
      const cardWidth = 380;
      scrollContainerRef.current.scrollTo({ left: index * cardWidth, behavior: 'smooth' });
      setActiveIndex(index);
    }
  };

  return (
    <section className="testimonials-section" id="testimonials">
      <div className="testimonials-bg-pattern"></div>
      
      <div className="testimonials-wrapper">
        <div className="testimonials-header">
          <div className="title-container">
            <div className="title-badge">
              <FaYoutube className="badge-icon" />
              <span>Success Stories</span>
            </div>
            <h2 className="testimonials-title">
              <span className="title-text">Témoignages</span>
              <span className="title-highlight"> Vidéo</span>
            </h2>
            <div className="testimonials-line"></div>
          </div>
          <p className="testimonials-intro">
            Découvrez les expériences authentiques de nos étudiants à travers leurs témoignages vidéo
          </p>
        </div>

        <div className="testimonials-controls">
          <button className="nav-btn prev-btn" onClick={scrollLeft}>
            <div className="btn-icon"><FaChevronLeft /></div>
          </button>
          
          <div className="testimonials-scroll-container" ref={scrollContainerRef}>
            <div className="testimonials-horizontal-grid">
              {testimonials.map((testimonial, index) => (
                <div 
                  className="testimonial-item-card" 
                  key={testimonial.id}
                  onMouseEnter={() => setHoveredCard(testimonial.id)}
                  onMouseLeave={() => setHoveredCard(null)}
                >
                  <div className="card-video-wrapper" onClick={() => openVideoModal(testimonial)}>
                    <div className="video-thumbnail">
                      <img src={testimonial.thumbnail} alt={testimonial.name} />
                      <div className="video-overlay">
                        <div className="play-button">
                          <FaPlay className="play-icon" />
                        </div>
                        <div className="video-duration">{testimonial.duration}</div>
                      </div>
                      {hoveredCard === testimonial.id && (
                        <div className="video-hover-effect">
                          <div className="hover-wave"></div>
                        </div>
                      )}
                    </div>
                    <div className="youtube-badge">
                      <FaYoutube /><span>YouTube</span>
                    </div>
                  </div>

                  <div className="card-content">
                    <div className="card-quote-icon"><FaQuoteLeft /></div>
                    <div className="card-quote-text">{testimonial.quote}</div>
                    <div className="card-author-info">
                      <div className="author-avatar">
                        <div className="avatar-initials">
                          {testimonial.name.split(' ').map(n => n[0]).join('')}
                        </div>
                      </div>
                      <div className="author-details">
                        <h4 className="author-name-text">{testimonial.name}</h4>
                        <div className="author-country-box">
                          <span className="country-name">{testimonial.country}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <button className="nav-btn next-btn" onClick={scrollRight}>
            <div className="btn-icon"><FaChevronRight /></div>
          </button>
        </div>

        <div className="testimonials-scroll-dots">
          {testimonials.map((_, index) => (
            <button 
              key={index} 
              className={`scroll-dot ${activeIndex === index ? 'active' : ''}`}
              onClick={() => scrollToIndex(index)}
            />
          ))}
        </div>

        <div className="testimonials-stats">
          <div className="stat-item">
            <div className="stat-number">{testimonials.length}+</div>
            <div className="stat-label">Témoignages</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">100%</div>
            <div className="stat-label">Satisfaction</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">15+</div>
            <div className="stat-label">Pays représentés</div>
          </div>
        </div>
      </div>

      {showVideoModal && selectedVideo && (
        <div className="video-modal" onClick={closeVideoModal}>
          <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeVideoModal}>×</button>
            <div className="video-container">
              <iframe
                ref={videoPlayerRef}
                width="100%"
                height="100%"
                src={`https://www.youtube.com/embed/${selectedVideo.videoId}?autoplay=1&rel=0`}
                title={selectedVideo.name}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="video-modal-info">
              <h3>{selectedVideo.name}</h3>
              <p>{selectedVideo.country}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Testimonials;